import { getUserById } from '../../../helpers/getUserById';
import { getUserName } from '../../../helpers/getUsername';

export const getSeenMessage = (seen, users, currenUserId) =>
	'seen by ' +
	seen
		.filter((userId) => userId !== currenUserId)
		.map((userId) => getUserName(getUserById(userId, users)))
		.join(', ');
